import React, { createContext, useState } from 'react';
import PerformAssessments from './Assessments'
import { AssessmentDefDrawer } from '../AssessmentDef';

const PerformAssessmentsPage = (props) => {
    const { isPractices } = props

    const [currentAssessmentDef, setCurrentAssessmentDef] = useState(null)
    const [openAssesmentDefDrawer, setOpenAssesmentDefDrawer] = useState(false)

    const commonValue = {
        currentAssessmentDef, setCurrentAssessmentDef,
        openAssesmentDefDrawer, setOpenAssesmentDefDrawer,
        isPractices
    }

    return (
        <PerformAssessmentContext.Provider value={commonValue}>
            <PerformAssessments {...props} />
            <AssessmentDefDrawer
                open={openAssesmentDefDrawer}
                handleDrawer={setOpenAssesmentDefDrawer}
                assessmentDefId={currentAssessmentDef}
            />
        </PerformAssessmentContext.Provider>
    )
}

export const PerformAssessmentContext = createContext()
export default PerformAssessmentsPage
